export const unverifiedModalToggle: HTMLButtonElement = document.getElementById("unverified-user-modal-toggle") as HTMLButtonElement
const script: HTMLScriptElement = document.getElementById("login-script") as HTMLScriptElement;
export const apiKey: string = script.dataset.apiKey!;
export const authDomain: string = script.dataset.authDomain!;